
export default class Vote{

    constructor(){
        this.modal = document.querySelector('.js-vote-modal');

        this._init();
    }


    showModal(index){
        this.modal.setAttribute('data-vote', index);
        BOCCHI.hashCount.sendAPI(index);
    }


    _init(){
        this._setEvent();
    }


    _setEvent(){
        
        // modal open
        document.querySelectorAll('.js-vote_open').forEach($open=>{

            $open.addEventListener('click', ()=>{
                const index = $open.getAttribute('data-index');
                this.showModal(index);
            });
        });

        // 投票ボタン
        document.querySelector('.js-vote_btn').addEventListener('click', ()=>{
            //const sceneId = this.modal.getAttribute('data-vote');
            //BOCCHI.hashCount.sendAPI(sceneId);
            this._vote();
        });
    }


    _vote(){
        const idx =  this.modal.getAttribute('data-vote');
        const url = `https://bocchi.rocks/omnibus/special/impression/?id=${idx}`;
        const hashtags = `#総集編ぼっち感想 #いいねくれー #ぼっち・ざ・ろっく`;
        const txt = encodeURIComponent(`${url} ${hashtags}`);
        window.open(`https://twitter.com/intent/tweet?text=${txt}`);
    }
}